import React from 'react';
import classNames from 'classnames';

import css from './IconEyeOff.module.css';

/**
 * Closed eye icon, shown when a visible password can be hidden.
 * Paths match the auth eye used on login and signup.
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to components own root class
 * @param {string?} props.rootClassName overwrite components own root class
 * @param {string?} props.ariaLabel accessible label for the icon
 * @returns {JSX.Element} SVG icon
 */
const IconEyeOff = props => {
  const { className, rootClassName, ariaLabel } = props;
  const classes = classNames(rootClassName || css.root, className);
  const roleInfo = ariaLabel ? { role: 'img', 'aria-label': ariaLabel } : { 'aria-hidden': 'true' };

  return (
    <svg
      className={classes}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...roleInfo}
    >
      <path
        d="M4.288 4.347C2.812 5.261 1.954 6.577 1.544 7.356C1.403 7.626 1.332 7.761 1.332 8.006C1.332 8.251 1.403 8.385 1.544 8.654C2.218 9.938 4.11 12.68 7.977 12.68C9.496 12.68 10.71 12.257 11.665 11.665"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.586 6.586C6.224 6.948 6 7.448 6 8C6 9.105 6.895 10 8 10C8.552 10 9.052 9.776 9.414 9.414"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M1.332 1.333L14.665 14.666"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.668 3.432C7.064 3.368 7.484 3.333 7.93 3.333C11.851 3.333 13.77 6.036 14.453 7.301C14.596 7.566 14.668 7.698 14.668 7.94C14.668 8.182 14.596 8.315 14.452 8.581C14.247 8.962 13.929 9.472 13.479 10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default IconEyeOff;
